// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useDeliveryManagerApi } from '../../hooks/useAdminDeliveryManager';

export const UseCreateDeliveryManager = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createDeliveryManager } = useDeliveryManagerApi();
  return useMutation({
    mutationKey: ['CreateDeliveryManager'],
    mutationFn: (data: any) => createDeliveryManager(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'DeliveryManager created successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getDeliveryManager'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create DeliveryManager',
        'error'
      );
    },
  });
};

export const usePatchdeliveryManager = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useDeliveryManagerApi();

  return useMutation({
    mutationKey: ['PatchDeliveryManager'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === 'unblocked' ? 'unblocked' : 'blocked';
      showMessage(`DeliveryManager ${action} successfully`, 'success');
      queryClient.invalidateQueries({
        queryKey: ['getDeliveryManager'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to block the DeliveryManager',
        'error'
      );
    },
  });
};

export const useDeleteDeliveryManager = () => {
  const queryClient = useQueryClient();
  const { deleteDeliveryManager } = useDeliveryManagerApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeletegetDeliveryManager'],
    mutationFn: (ids: string[]) => {
      return deleteDeliveryManager(ids);
    },
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'DeliveryManager deleted successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getDeliveryManager'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to deleted DeliveryManager',
        'error'
      );
    },
  });
};

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useAllDeliveryManager = (queryParams: Params) => {

  const { getAllDeliveryManager } = useDeliveryManagerApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getDeliveryManager',queryParams ],
    queryFn: () => {
      return getAllDeliveryManager(queryParams);
    },
  });
  
  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};

export const useEditDeliveryManager = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editDeliveryManager } = useDeliveryManagerApi();

  return useMutation({
    mutationKey: ['EditditDeliveryManager'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editDeliveryManager(id, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'DeliveryManager Updated successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getDeliveryManager'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to update the DeliveryManager',
        'error'
      );
    },
  });
};
